import {Model} from '@vuex-orm/core';
import Seminar from "./seminarModel";

export default class EventSeries extends Model {

    static entity = 'eventSeries';
    static primaryKey = 'id_event_series';

    static fields() {
        return {
            id_event_series: this.number(null),
            year_group: this.attr(null),
            school_year: this.attr(null),
            seminars: this.hasMany(Seminar, 'id_event_series', 'id_event_series'),
            seminar_count: this.attr(null),
        };
    }

    getYearGroupString() {
        return `Jahrgang ${this.year_group}`;
    }

    getSchoolYearString() {
        return `${this.getSchoolYearNumber()}. Schuljahr (${this.school_year}/${this.school_year+1})`;
    }

    getSchoolYearNumber() {
        return this.school_year - this.year_group + 1;
    }
}